/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AutomationRule,
  CreateAutomationRuleRequest,
  ErrorEnvelope,
  ListAutomationRulesResponse,
  ListAutomationRunsResponse,
  UpdateAutomationRuleRequest,
} from '../models/index';
import {
    AutomationRuleFromJSON,
    AutomationRuleToJSON,
    CreateAutomationRuleRequestFromJSON,
    CreateAutomationRuleRequestToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    ListAutomationRulesResponseFromJSON,
    ListAutomationRulesResponseToJSON,
    ListAutomationRunsResponseFromJSON,
    ListAutomationRunsResponseToJSON,
    UpdateAutomationRuleRequestFromJSON,
    UpdateAutomationRuleRequestToJSON,
} from '../models/index';

export interface CreateAutomationRuleOperationRequest {
    createAutomationRuleRequest: CreateAutomationRuleRequest;
}

export interface DeleteAutomationRuleRequest {
    ruleId: number;
}

export interface GetAutomationRuleByIdRequest {
    ruleId: number;
}

export interface ListAutomationRuleRunsRequest {
    ruleId: number;
    limit?: number;
}

export interface UpdateAutomationRuleOperationRequest {
    ruleId: number;
    updateAutomationRuleRequest: UpdateAutomationRuleRequest;
}

/**
 * AutomationsApi - interface
 * 
 * @export
 * @interface AutomationsApiInterface
 */
export interface AutomationsApiInterface {
    /**
     * 
     * @summary Create automation rule
     * @param {CreateAutomationRuleRequest} createAutomationRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApiInterface
     */
    createAutomationRuleRaw(requestParameters: CreateAutomationRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutomationRule>>;

    /**
     * Create automation rule
     */
    createAutomationRule(requestParameters: CreateAutomationRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutomationRule>;

    /**
     * 
     * @summary Delete automation rule
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApiInterface
     */
    deleteAutomationRuleRaw(requestParameters: DeleteAutomationRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete automation rule
     */
    deleteAutomationRule(requestParameters: DeleteAutomationRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get automation rule by ID
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApiInterface
     */
    getAutomationRuleByIdRaw(requestParameters: GetAutomationRuleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutomationRule>>;

    /**
     * Get automation rule by ID
     */
    getAutomationRuleById(requestParameters: GetAutomationRuleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutomationRule>;

    /**
     * 
     * @summary List recent runs for an automation rule
     * @param {number} ruleId 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApiInterface
     */
    listAutomationRuleRunsRaw(requestParameters: ListAutomationRuleRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAutomationRunsResponse>>;

    /**
     * List recent runs for an automation rule
     */
    listAutomationRuleRuns(requestParameters: ListAutomationRuleRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAutomationRunsResponse>;

    /**
     * 
     * @summary List automation rules for the current company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApiInterface
     */
    listAutomationRulesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAutomationRulesResponse>>;

    /**
     * List automation rules for the current company
     */
    listAutomationRules(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAutomationRulesResponse>;

    /**
     * 
     * @summary Update automation rule (including active toggle)
     * @param {number} ruleId 
     * @param {UpdateAutomationRuleRequest} updateAutomationRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApiInterface
     */
    updateAutomationRuleRaw(requestParameters: UpdateAutomationRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutomationRule>>;

    /**
     * Update automation rule (including active toggle)
     */
    updateAutomationRule(requestParameters: UpdateAutomationRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutomationRule>;

}

/**
 * 
 */
export class AutomationsApi extends runtime.BaseAPI implements AutomationsApiInterface {

    /**
     * Create automation rule
     */
    async createAutomationRuleRaw(requestParameters: CreateAutomationRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutomationRule>> {
        if (requestParameters['createAutomationRuleRequest'] == null) {
            throw new runtime.RequiredError(
                'createAutomationRuleRequest',
                'Required parameter "createAutomationRuleRequest" was null or undefined when calling createAutomationRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/automations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAutomationRuleRequestToJSON(requestParameters['createAutomationRuleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AutomationRuleFromJSON(jsonValue));
    }

    /**
     * Create automation rule
     */
    async createAutomationRule(requestParameters: CreateAutomationRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutomationRule> {
        const response = await this.createAutomationRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete automation rule
     */
    async deleteAutomationRuleRaw(requestParameters: DeleteAutomationRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling deleteAutomationRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/automations/{ruleId}`.replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters['ruleId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete automation rule
     */
    async deleteAutomationRule(requestParameters: DeleteAutomationRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAutomationRuleRaw(requestParameters, initOverrides);
    }

    /**
     * Get automation rule by ID
     */
    async getAutomationRuleByIdRaw(requestParameters: GetAutomationRuleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutomationRule>> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling getAutomationRuleById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/automations/{ruleId}`.replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters['ruleId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AutomationRuleFromJSON(jsonValue));
    }

    /**
     * Get automation rule by ID
     */
    async getAutomationRuleById(requestParameters: GetAutomationRuleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutomationRule> {
        const response = await this.getAutomationRuleByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List recent runs for an automation rule
     */
    async listAutomationRuleRunsRaw(requestParameters: ListAutomationRuleRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAutomationRunsResponse>> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling listAutomationRuleRuns().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/automations/{ruleId}/runs`.replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters['ruleId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAutomationRunsResponseFromJSON(jsonValue));
    }

    /**
     * List recent runs for an automation rule
     */
    async listAutomationRuleRuns(requestParameters: ListAutomationRuleRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAutomationRunsResponse> {
        const response = await this.listAutomationRuleRunsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List automation rules for the current company
     */
    async listAutomationRulesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAutomationRulesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/automations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAutomationRulesResponseFromJSON(jsonValue));
    }

    /**
     * List automation rules for the current company
     */
    async listAutomationRules(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAutomationRulesResponse> {
        const response = await this.listAutomationRulesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update automation rule (including active toggle)
     */
    async updateAutomationRuleRaw(requestParameters: UpdateAutomationRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutomationRule>> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling updateAutomationRule().'
            );
        }

        if (requestParameters['updateAutomationRuleRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAutomationRuleRequest',
                'Required parameter "updateAutomationRuleRequest" was null or undefined when calling updateAutomationRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/automations/{ruleId}`.replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters['ruleId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAutomationRuleRequestToJSON(requestParameters['updateAutomationRuleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AutomationRuleFromJSON(jsonValue));
    }

    /**
     * Update automation rule (including active toggle)
     */
    async updateAutomationRule(requestParameters: UpdateAutomationRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutomationRule> {
        const response = await this.updateAutomationRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
